"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "comano-terme": {
    "fa1935f5": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "bie": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b7e6f0e9": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "bleggio-inferiore": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "799c68e5": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "campo-maggiore": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9cccee59": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "castel-campo": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ffda5e4f": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "godenzo": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "863ba04f": [{
      "hkey": "b717fa88",
      "slug": "campo-lomaso",
      "name": "Campo Lomaso",
      "primary": true,
      "skipSearch": false
    }],
    "lomaso": [{
      "hkey": "b717fa88",
      "slug": "campo-lomaso",
      "name": "Campo Lomaso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "79554ebc": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "skipSearch": false
    }],
    "terme-di-comano": [{
      "hkey": "62dd7a96",
      "slug": "comano-terme",
      "name": "Comano Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f4386f0b": [{
      "hkey": "e7e27a9f",
      "slug": "algone",
      "name": "Algone",
      "primary": true,
      "skipSearch": false
    }],
    "val-d-algone": [{
      "hkey": "e7e27a9f",
      "slug": "algone",
      "name": "Algone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;